import { extend, configure } from "vee-validate";
import { required, email, max } from "vee-validate/dist/rules";

configure({
    // Use custom default message handler.
    defaultMessage: (field, values) => {
        values._field_ = `fields.${field}`;

        return `validation.${values._rule_}`, values;
    }
});

// Install required rule and message.
extend("required", required);

// Install email rule and message.
extend("email", email);

// Install max rule and message.
extend("max", max);